module.exports = __webpack_public_path__ + "media/images/hitfun/icon.mainmenu.home-d2bb32f4831dd9f9a61bf66e0a63ca27.svg";